export const quotes = [
  "Small steps lead to big wins.",
  "Dreams don’t work unless you do.",
  "Check it off—your future self will thank you.",
  "One task at a time, one victory at a time.",
  "Your goals are closer than you think.",
  "Write it down, make it happen.",
  "Every accomplishment starts with a decision to begin.",
  "Today’s tasks, tomorrow’s triumphs.",
  "Success is built on daily habits.",
  "Slay the list, conquer the day.",
  "No task is too small to matter.",
  "Done is better than perfect.",
  "Turn chaos into checkmarks.",
  "Your to-do list is the blueprint for greatness.",
  "Every checkbox is a small celebration.",
  "Start now, worry less.",
  "Focus on progress, not perfection.",
  "Little wins add up to big victories.",
  "Make today count—your tasks are waiting.",
  "One list to rule them all.",
  "Start where you are, use what you have, do what you can.",
  "What gets scheduled gets done.",
  "A clear list equals a clear mind.",
  "Your future starts with this next task.",
  "Big dreams require tiny steps.",
  "Keep going—success loves momentum.",
  "Ticking off tasks is the sound of progress.",
  "Own your day, own your life.",
  "Action cures procrastination.",
  "You can’t finish what you don’t start.",
  "The secret of getting ahead is getting started.",
  "Every tick is a triumph.",
  "Great things are built task by task.",
  "Your checklist is your compass.",
  "Don’t wait for inspiration—create it.",
  "A task a day keeps the stress away.",
  "Master your tasks, master your destiny.",
  "Do it now—your future self will thank you.",
  "Every small task is a step forward.",
  "Your list today, your legacy tomorrow.",
  "Momentum starts with the first tick.",
  "No dream is too big for a to-do list.",
  "Progress over perfection, always.",
  "Lists are temporary; triumphs are forever.",
  "The road to success is paved with completed tasks.",
  "A goal without a plan is just a wish—start planning.",
  "Success is built in the daily grind.",
  "Small efforts today create big impacts tomorrow.",
  "One checkbox at a time, one step closer to greatness.",
  "Lists don’t just organize your life; they shape your future.",
  "Every tick is a tiny act of self-care.",
  "Your tasks are opportunities in disguise.",
];
